/** Human-readable labels for CMS section keys (editor + admin UI). */
export const CMS_SECTIONS = [
  {
    key: "home_hero",
    label: "Home — hero title & intro",
    hint: "JSON keys: h1Html (recommended), paragraphHtml (optional), or plain h1 / paragraph.",
  },
  {
    key: "news_list",
    label: "News — listing cards",
    hint:
      "Array of objects: img (image URL string), heading, category, para. Icons use site defaults if omitted.",
  },
  {
    key: "events_list",
    label: "Events — listing cards",
    hint: "Same shape as news_list; used on /event when CMS row exists.",
  },
  {
    key: "site_settings",
    label: "Site — contact & labels",
    hint: "JSON: contactEmail, phone, orgName, etc. (extend as needed).",
  },
];
